import React from "react";
//import { Navbar } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

// Footer ahora mismo comentado ya que teniamos el fallo de que se pegaba arriba y salía en mitad de la pantalla
const Footer = () => {
  return (
    <div className="d-flex flex-column p-1" style={{alignItems:'center', color:'#ccc', backgroundColor:'#2a599f'}} expand="lg">
      <span>© <a href="https://www.stjteresianas.org/" style={{color:'#ccc'}}>Compañía de Santa Teresa de Jesús</a>  -  <a href='https://www.papayacore.com' style={{color:'#ccc'}}>Papayacore Software Engineering</a> </span>
    </div>
  )
}

export default Footer;

